export default "__VITE_ASSET__DSGfYKWV__"